import { render, staticRenderFns } from "./SettingsPaymentPingpongAccounts.vue?vue&type=template&id=52f27354&lang=pug&"
import script from "./SettingsPaymentPingpongAccounts.vue?vue&type=script&lang=js&"
export * from "./SettingsPaymentPingpongAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPaymentPingpongAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f27354')) {
      api.createRecord('52f27354', component.options)
    } else {
      api.reload('52f27354', component.options)
    }
    module.hot.accept("./SettingsPaymentPingpongAccounts.vue?vue&type=template&id=52f27354&lang=pug&", function () {
      api.rerender('52f27354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/settings/SettingsPayment/SettingsPaymentPingpongAccounts.vue"
export default component.exports